export default "__VITE_ASSET__nnECWTsX__"